import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitEnquiry = async (type, data) => {
  const response = await axios.post(`${API}/enquiries/${type}`, data);
  return response.data;
};

export const createCheckout = async (lookupKey, quantity = 1) => {
  const response = await axios.post(`${API}/payments/checkout`, {
    lookup_key: lookupKey,
    quantity,
    origin_url: window.location.origin,
  });
  return response.data;
};

export const getPaymentStatus = async (sessionId) => {
  const response = await axios.get(`${API}/payments/status/${sessionId}`);
  return response.data;
};
